<template>
	<div class="versionInformation disBetween">
		<div class="statisticalLeft">
			<el-form :model="itemObj" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class="diaItem disBetween">
					<div class="diaTpye disStart">
						<el-form-item class="lableBox" label="升级版本" prop="amountActivityName">
							<div class="myinputBox">
								<el-select v-model="itemObj.versionId" placeholder="请选择版本" clearable>
									<el-option v-for="item in versionList" :key="item.versionId"
										:label="item.versionName" :value="item.versionId">
									</el-option>
								</el-select>
							</div>
						</el-form-item>
					</div>
					<div class="diaTpye disStart">
						<el-form-item class="lableBox" label="升级时间" prop="amountActivityName">
							<div class="myinputBox">
								<el-date-picker v-model="itemObj.levelUpTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"
									:picker-options="pickerOptions">
								</el-date-picker>
							</div>
						</el-form-item>
					</div>
					<!-- <div class="diaTpye diaTpye2 disStart">
						<el-form-item class="lableBox" label="" prop="file">
							<div class="myinputBox myinputBox3">
								<el-upload class="avatar-uploader disBetween" :auto-upload="autoUpload"
									:on-progress="onProgress" :before-upload="beforeUpload" :on-change="getFile2"
									action="certmanage" :on-remove="handleRemove" :limit="1" :on-exceed="handleExceed"
									:file-list="fileList">
									<el-button size="small" type="primary">点击上传升级包</el-button>
								</el-upload>
							</div>
						</el-form-item>
					</div> -->
				</div>
				<div class="diaItem disBetween">
					<div class="diaTpye ">
						<el-form-item class="lableBox" label="升级设备" prop="amountActivityName">
							<div class="disBetween">
								<!-- <div class="myinputBox lastchoiceBox disStart">
									<div class="communityList ellipsis">
										<span v-for="(item,inx) in itemObj.areaList.slice(0,3)"
											class="community">{{item.areaName}}
											<span
												v-if="itemObj.areaList.length>0 && inx<itemObj.areaList.slice(0,3).length-1">、</span>
										</span>
										<span class="community" v-if="itemObj.areaList.length>3">...</span>
									</div>
									<span class="choice" @click="dialogDispose1=true">选择地区</span>
								</div> -->
								<div class="myinputBox lastchoiceBox disStart">
									<div class="communityList ellipsis">
										<span v-for="(item,inx) in itemObj.communityEquipmentList.slice(0,10)"
											class="community">{{item.communityEquipmentName}}<span
												v-if="itemObj.communityEquipmentList.length>0 && inx<itemObj.communityEquipmentList.slice(0,10).length-1">、</span></span>
										<span class="community"
											v-if="itemObj.communityEquipmentList.length>10">...</span>
									</div>
									<span class="choice" @click="choiceEquipment">选择设备</span>
								</div>
							</div>
						</el-form-item>
					</div>
				</div>
				<div class="disStart">
					<span class="dataBox">
						当前平台设备共计{{all}},选择升级设备共{{ itemObj.communityEquipmentList.length}}台
					</span>
					<el-button type="success" @click="levelUp">远程升级</el-button>
				</div>
			</el-form>

		</div>
		<el-dialog title="选择地区" center class="mydialog2" :close-on-click-modal="NOfalse" :visible.sync="dialogDispose1"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="disposeBox disBetween">
					<div class="disposeLeft">
						<div class="choiceBox">选择地区</div>
						<div class="moduleList">
							<el-tree highlight-current :props="props2" :load="loadNode1" lazy @node-click="nodeClick1">
							</el-tree>
						</div>
					</div>
					<div class="linBox"></div>
					<div class="disposeRight">
						<div class="choiceBox">地区名称</div>
						<div class="moduleList">
							<div v-for="(item,inx) in menuList1" :key="inx" class="itemBox disStart">
								<span class="titleBox">{{item.areaName}}</span>
								<el-checkbox v-model="item.checkFlag" @change="menuClick1($event,item,inx)">
								</el-checkbox>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button @click="dialogDispose1 = false">取 消</el-button>
					<el-button type="primary" @click="savedialogDispose1">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="选择设备" center class="mydialog2" :close-on-click-modal="NOfalse" :visible.sync="dialogDispose2"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="disposeBox disBetween">
					<div class="disposeLeft">
						<div class="choiceBox">选择地区/社区</div>
						<div class="moduleList">
							<el-tree highlight-current :props="props2" :load="loadNode2" lazy @node-click="nodeClick2">
							</el-tree>
						</div>
					</div>
					<div class="linBox"></div>
					<div class="disposeRight">
						<div class="choiceBox">设备</div>
						<div class="moduleList">
							<div v-for="(item,inx) in menuList2" :key="inx" class="itemBox disStart">
								<span class="titleBox">{{item.communityEquipmentName}}</span>
								<el-checkbox v-model="item.checkFlag" @change="menuClick2($event,item,inx)">
								</el-checkbox>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button @click="closeDialogDispose2">取 消</el-button>
					<el-button type="primary" @click="savedialogDispose2">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: "versionInformation",
		data() {
			return {
				versionList: [],
				NOfalse: false,
				dialogDispose1: false,
				dialogDispose2: false,
				menuList1: [],
				menuList2: [],
				saveArr1: [],
				saveArr2: [],
				props2: {
					label: 'areaName',
					value: "areaCode",
					isLeaf: 'leaf'
				},
				itemObj: {
					amountActivitySetList: [],
					areaList: [],
					amountActivityName: "",
					activityStartTime: "",
					activityEndTime: "",
					communityEquipmentList: [],
					levelUpTime: ""
				},
				all: 0,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7; //只能选择今天及今天之后的日期
						//return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后的日期，今天的日期也不能选
					}
				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				// this.selectParamConfigByCode()
				this.getList()
				this.getEquipmentNum()
			})
		},
		methods: {
			choiceEquipment() {
				this.dialogDispose2 = true
				console.log(this.menuList2)
				this.$set(this, "saveArr2", JSON.parse(JSON.stringify(this.itemObj.communityEquipmentList)))
				for (let k of this.menuList2) {
					this.$set(k, "checkFlag", false)
					for (let j of this.itemObj.communityEquipmentList) {
						if (j.communityEquipmentId == k.communityEquipmentId) {
							this.$set(k, "checkFlag", true)
						}
					}
				}
			},
			levelUp() {
				let that=this
				if (!this.itemObj.versionId) {
					this.$message({
						message: "请选择升级版本",
						type: 'warning'
					});
					return false
				}
				if (this.itemObj.communityEquipmentList.length <= 0) {
					this.$message({
						message: "请选择升级设备",
						type: 'warning'
					});
					return false
				}
				if (!this.itemObj.levelUpTime) {
					this.$message({
						message: "请选择升级时间",
						type: 'warning'
					});
					return false
				}
				
				let obj={
					updateTime:this.itemObj.levelUpTime,
					versionId:this.itemObj.versionId,
					equipmentIdList:[]
					
				}
				for(let k of this.itemObj.communityEquipmentList){
					obj.equipmentIdList.push(k.communityEquipmentId)
				}
				console.log(this.itemObj.communityEquipmentList)
				this.$confirm('是否确认升级所选设备?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$api.addUpdateRecord(obj).then((res) => {
						if (res.returnCode == 200) {
							that.$message({
								type: 'success',
								message: '操作成功!'
							});
							setTimeout(() => {
								this.$emit('moduleOne')
							}, 500)
						}
					})
				}).catch(() => {
				
				});
			},
			getList() {
				this.$api.listAllVersion({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "versionList", res.obj)
					}
				})
			},
			getEquipmentNum() {
				this.$api.countEquipmentNum({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "all", res.obj)
					}
				})
			},
			// 请选择社区类型
			selectChange(e) {
				console.log(e)
			},
			savedialogDispose1() {
				this.dialogDispose1 = false
				this.$set(this.itemObj, "areaList", this.saveArr1)
				// this.$set(this,"saveArr2",[])
			},
			closeDialogDispose2() {
				this.dialogDispose2 = false
				this.$set(this, "saveArr2", [])
			},
			savedialogDispose2() {
				this.dialogDispose2 = false
				this.$set(this.itemObj, "communityEquipmentList", JSON.parse(JSON.stringify(this.saveArr2)))
				this.$set(this, "saveArr2", [])
			},
			loadNode1(node, resolve) {
				let that = this
				let id = ""
				if (node.data) {
					// if()
					id = node.data.areaCode
				}
				let lastFlag = true
				if (node.level == 1) {
					if (node.data.areaName == "北京市" || node.data.areaName ==
						"天津市" ||
						node.data.areaName == "上海市" || node.data.areaName == "重庆市" || node.data
						.areaName == "香港特别行政区" || node.data
						.areaName == "澳门特别行政区") {
						lastFlag = false
						resolve([])
					}
				} else if (node.level == 2) {
					lastFlag = false
					resolve([])
				}
				if (lastFlag) {
					this.$api.listAreaInfoAndCommunity({
						parentAreaCode: id
					}).then((res) => {
						if (res.returnCode == 200) {

							return resolve(res.obj.list)
						}
					})
				}
			},

			nodeClick1(n, node, l) {
				let that = this
				let lastFlag = false
				if (node.level == 1) {
					if (node.data.areaName == "北京市" || node.data.areaName ==
						"天津市" ||
						node.data.areaName == "上海市" || node.data.areaName == "重庆市" || node.data
						.areaName == "香港特别行政区" || node.data
						.areaName == "澳门特别行政区") {
						lastFlag = true
					}
				} else if (node.level == 2) {
					lastFlag = true
				}
				this.saveArr1 = JSON.parse(JSON.stringify(this.itemObj.areaList))
				if (lastFlag) {
					this.$api.listAreaInfoAndCommunity({
						parentAreaCode: n.areaCode
					}).then((res) => {
						if (res.returnCode == 200) {
							for (let j of res.obj.list) {
								that.$set(j, "checkFlag", false)
								for (let k of that.itemObj.areaList) {
									if (j.areaCode == k.areaCode) {
										that.$set(j, "checkFlag", true)
									}
								}
							}
							that.$set(that, "menuList1", res.obj.list)
						}
					})
				}


			},
			loadNode2(node, resolve) {
				let id = ""
				if (node.data) {
					// if()
					id = node.data.areaCode
				}

				this.$api.listAreaInfoAndCommunity({
					parentAreaCode: id
				}).then((res) => {
					if (res.returnCode == 200) {
						if (res.obj.type == 1) {
							// for (let k of res.obj.list) {
							// 	if (node.level == 1) {
							// 		if (node.data.areaName == "北京市" || node.data.areaName ==
							// 			"天津市" ||
							// 			node.data.areaName == "上海市" || node.data.areaName == "重庆市" || node
							// 			.data
							// 			.areaName == "香港特别行政区" || node.data
							// 			.areaName == "澳门特别行政区") {
							// 			k.leaf = false
							// 		}
							// 	} else if (node.level == 2) {
							// 		k.leaf = false
							// 	}
							// }
							// console.log(res.obj.list)
							return resolve(res.obj.list)
						} else {
							console.log(res.obj.list)
							let arr = []
							for (let k of res.obj.list) {
								arr.push({
									areaCode: k.communityId,
									areaName: k.communityName,
									childList: [],
									leaf: true,
								})
							}
							return resolve(arr)
						}
					}
				})
			},
			nodeClick2(n, m, l) {
				if (n.leaf) {
					this.$api.listCommunityEquipment({
						communityId: n.areaCode, //社区编号
						communitySiteId: "",
						communityEquipmentNo: "",
						equipmentStatus: "",
						equipmentRunStatus: "",
						pageNo: 1, //当前页
						pageSize: 1000, //当前页个数
					}).then((res) => {
						console.log(res)
						for (let j of res.obj.list) {
							this.$set(j, "checkFlag", false)
							for (let k of this.saveArr2) {
								if (j.communityEquipmentId == k.communityEquipmentId) {
									this.$set(j, "checkFlag", true)
								}
							}
						}

						this.$set(this, "menuList2", res.obj.list)
					})
				}
			},
			menuClick1(e, item, inx, ) {
				this.$nextTick(() => {
					if (e == false) {
						let index = this.saveArr1.findIndex((res) => {
							return res.areaCode == item.areaCode
						})
						if (index != -1) {
							this.saveArr1.splice(index, 1)
						}
					} else {
						this.saveArr1.push(item)
					}
					this.$set(this.itemObj, "areaList", this.saveArr1)

				})
			},
			menuClick2(e, item, inx, ) {
				this.$nextTick(() => {
					if (e == false) {
						let index = this.saveArr2.findIndex((res) => {
							return res.communityEquipmentId == item.communityEquipmentId
						})
						if (index != -1) {
							this.saveArr2.splice(index, 1)
						}
					} else {
						this.saveArr2.push(item)
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./versionInformation.scss";
</style>